import { render, staticRenderFns } from "./text-divider.vue?vue&type=template&id=8823e082"
import script from "./text-divider.vue?vue&type=script&lang=js"
export * from "./text-divider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports